import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccessoryBodyTypeTabName from '../../containers/accessory-body-type-tab-name';

const AccessoryBodyTypeTabNameBlock = props => <AccessoryBodyTypeTabName {...props} />;
AccessoryBodyTypeTabNameBlock.displayName = 'AccessoryBodyTypeTabName';

export default withDynamicComponents({
  componentWhitelist: [

  ],
  mapInputToOutput: [
    
  ],
})(AccessoryBodyTypeTabNameBlock);



// WEBPACK FOOTER //
// ./src/blocks/accessory-body-type-tab-name/index.jsx